/**
 * The field every badge surface reads. Spelled once: it is the link between this eviction and
 * `TranslationStatusFragment`, and a rename that misses one of the two would leave badges stale
 * with nothing to show why.
 */const TRANSLATION_STATUSES_FIELD='translationStatuses';/**
 * Drops `translationStatuses` from every cached object that has it, so the next read of any query
 * selecting the field misses the cache and goes to the network.
 *
 * WHY this exists next to `refetchQueries({ include: 'active' })`, which the notification handler
 * already does: `active` means MOUNTED. A run started from a badge is started on a surface that
 * shows badges, so its query is active and the refetch is enough. The /settings/blocks bulk
 * button is not - it sits on the overview page, and the block lists that show the badges live one
 * route deeper. Nothing was mounted to refetch, and navigating there afterwards read the
 * pre-run statuses straight out of the cache: single blocks updated their badges by themselves,
 * the bulk run appeared to do nothing (Marcel).
 *
 * Deleting the FIELD rather than evicting objects or naming queries, for three reasons:
 *
 * - It is surface-independent. Badges are read by the /library cards, the /settings/blocks rows,
 *   the consultation and information-clarification pages and their sidebars, each through its own
 *   query. A list of query names is a list the next badge surface has to remember to extend -
 *   the same objection that made the refetch above use `include: 'active'`.
 * - It keeps everything else cached. The block's name, its content blocks and its media survive,
 *   so the refetch is a normal query rather than a cold start.
 * - It cannot write a wrong shape. The alternative - patching the counts in the cache from the
 *   notification - is what this feature already got wrong once: the payload does not carry them.
 */export const evictTranslationStatuses=cache=>{// `extract()` walks the whole normalised store, which is why this runs on a finished
// translation run and nothing else: those arrive minutes apart, at most one per language.
//
// The cast is the one place this file knows more than its parameter type does: `ApolloCache`
// is generic over its serialised form, and `client.cache` is typed as `ApolloCache<object>`,
// but the app's cache is the `InMemoryCache` built in `config/apolloSetup.tsx`, whose extract
// IS a NormalizedCacheObject. Taking the narrower type as the parameter instead would push the
// same cast onto every caller.
const normalized=cache.extract();Object.entries(normalized).forEach(_ref=>{let[id,entity]=_ref;if(!entity||typeof entity!=='object')return;if(!(TRANSLATION_STATUSES_FIELD in entity))return;cache.modify({id,fields:{[TRANSLATION_STATUSES_FIELD]:(_value,_ref2)=>{let{DELETE}=_ref2;return DELETE;}}});});};export default evictTranslationStatuses;